/* eslint-disable @typescript-eslint/naming-convention */
import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { ClientStats } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import { invert } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { fetchJson } from '@swf/core/utils/api';

import styles from './CMSClientStats.scss';

interface Stats {
  active_tournaments: number;
  players: number;
  tables: number;
}

interface ClientSiteData {
  tournaments: {
    host: {
      site: {
        id: string;
        active_tournaments: number;
        players: number;
        tables: number;
        play_money: Stats;
      }[];
    };
  };
}

const CMSClientStats: React.FC<ClientStats> = ({
  players_online,
  active_tournaments,
  feed_url
}) => {
  const [data, setData] = useState<Stats>();
  const siteName = useSelector(select.cms.getSiteName);
  const siteNames = invert(Sites);

  useEffect(() => {
    if (feed_url) {
      fetchJson(feed_url).then((result: ClientSiteData) => {
        const site = siteName === siteNames[Sites.NET] ? siteNames[Sites.COM] : siteName;
        const data = result.tournaments.host.site?.filter((siteData) => siteData.id === site)[0];
        setData(siteName === siteNames[Sites.NET] ? data?.play_money : data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return null;
  }

  return (
    <div className={styles.clientStats}>
      <div>
        <p className={classNames(styles.statsNumber, styles.playersCount)}>
          {Number(data.players).toLocaleString()}
        </p>
        <span>{players_online}</span>
      </div>
      <div>
        <p className={classNames(styles.statsNumber, styles.tournamentsCount)}>
          {Number(data.active_tournaments).toLocaleString()}
        </p>
        <span>{active_tournaments}</span>
      </div>
    </div>
  );
};

export default CMSClientStats;
